import React from "react";
import { Isvg } from "../../../../../components";

export default class PinButton extends React.Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }
  componentDidMount() {
    const { focus, pin } = this.props;
    focus && pin && this[pin].focus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { focus, pin } = this.props;
    focus && pin && this[pin].focus();
  }

  onClick() {
    const { pin, setTargetPin } = this.props;
    setTargetPin && pin && setTargetPin(pin);
  }

  image() {
    const { move, pin } = this.props;
    if (pin) {
      return (
        <Isvg
          src={`/img/assignments/assets/img/assignments_${
            move ? "move_" : ""
          }${pin}_pin.svg`}
          key={`${pin}${move ? "_pin" : "_move"}`}
        />
      );
    }
  }

  render() {
    const { pin } = this.props;
    return (
      <button
        ref={button => {
          this[pin] = button;
        }}
        className="transparentButton"
        onClick={this.onClick}
      >
        {this.image()}
        <span>{i18n.t(`assignments.${pin ? pin : "drop"}-pin`)}</span>
      </button>
    );
  }
}

PinButton.defaultProps = {
  move: false
};
